import { useMutation, useQuery } from "@tanstack/react-query";
import apiClient from "@apis/index";
import Routes from "@apis/routes";
import { useUserInfo } from "@redux/slices/userInfoSlice";
import { UserListResponse } from "@src/types/UserList";

export const useGetUserList = (page: number) => {
  const { user } = useUserInfo();
  return useQuery({
    queryKey: ["USER_LIST", user?.is_admin_true],
    enabled: user?.is_admin_true,
    queryFn: () =>
      apiClient
        .get<UserListResponse>(Routes.USER_LIST, {
          params: {
            page: page,
          },
          headers: {
            ...apiClient.defaults.headers.common,
            "If-None-Match": "",
          },
        })
        .then((response) => {
          return response?.data;
        }),
  });
};

export const useUpdateUser = () => {
  return useMutation({
    mutationFn: ({
      userId,
      data,
    }: {
      userId: number;
      data: {
        status?: string;
        is_company_admin?: boolean;
        paid_plan_user?: boolean;
      };
    }) =>
      apiClient.put(Routes.UPDATE_USER(userId), {
        user: data,
      }),
  });
};
